<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <h4 class="modal-title wrap-text-in ng-binding">
        <span> {{label}} </span>
    </h4>
</div>

<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="main-box">
                            <div class="main-box-header text-center">
                                <h4>Assessment 'Send' Status by Candidate</h4>
                            </div>
                            <div class="main-box-body" style="max-height: 250px; overflow-y: scroll;">
                                <div class="row">
                                    <div class="col-xs-12" *ngFor="let jobMatch of sendResultsArray">
                                        <div [ngClass]="{'bg-success': jobMatch.isSuccess, 'bg-danger': !jobMatch.isSuccess}" style="margin: 3px; padding: 3px; padding-left: 8px; border-radius: 5px;">
                                            <span class="fa" [ngClass]="{'fa-check green': jobMatch.isSuccess, 'fa-times red': !jobMatch.isSuccess}"></span>
                                            <strong [ngClass]="{'green': jobMatch.isSuccess, 'red': !jobMatch.isSuccess}"> {{ jobMatch.name }}</strong> -
                                            <span> {{jobMatch.status}} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-right">
                        <div class="clearfix">
                            <button type="button" class="btn btn-info pull-right" style="margin-left: 5px" (click)="closeModal()">
                                <span>Close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>